// src/reducers/redux-store.ts
import { combineReducers } from 'redux';
import masterdataReducer from './masterdata';
import soundReducer from 'src/components/parcel-connect/redux/reducer';
import referralsReducer from './referrals';
import uiThemeReducer from 'src/theming/uiThemeReducer';

const rootReducer = combineReducers({
  // This key decides how your store is structured, e.g. state.masterdata
  masterdata: masterdataReducer,
  sound: soundReducer,
  referrals: referralsReducer,
  uiTheme: uiThemeReducer,
});

export default rootReducer;
